import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { NsxTApiSettingsDefaults } from './types';

export const nsxTDefaults: NsxTApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 40,
  maxCapacity: 100,
  refillRate: 50,
  keepAlive: false,
  defaultSessionTimeoutSec: 0,
  serverRateLimiterSettingsRefillRateFactorPct: 50,
  serverRateLimiterSettingsSafetyFactorPct: 75,
};
